module.exports = __webpack_public_path__ + "static/media/service1.93a346b0.svg";